export default __webpack_public_path__ + "static/media/localtext.8e6ee53f.csv";